import React from 'react'

import TrixEditor from 'Src/b/components/TrixEditor'

const StepEditor = (props) => {
  const { uploadImage, ...rest } = props

  const handleImageUpload = async (event) => {
    const attachment = event.attachment

    if (attachment.file) {
      try {
        const formData = new FormData()
        formData.append('file', attachment.file)

        const data = await uploadImage(formData).unwrap()
        const { fileUrl } = data

        attachment.setAttributes({
          url: fileUrl,
          href: fileUrl
        })
      } catch (error) {
        console.error('Error while uploading image to server', error)
      }
    }
  }

  return <TrixEditor {...rest} onImageUpload={handleImageUpload} />
}

export default StepEditor
